import { default as domainAmbienceResource } from './resource/services'
import { default as domainAmbience } from './ambience/services'
import { default as domainAmbienceCategory } from './category/services'
import { default as domainAmbienceRoomReservation } from './room-reservation/services'
import { default as domainAmbienceScheduleActivity } from './schedule-activity/services'

export default {
    domainAmbienceResource,
    domainAmbience,
    domainAmbienceCategory,
    domainAmbienceRoomReservation,
    domainAmbienceScheduleActivity
}